import { render, staticRenderFns } from "./Arms.vue?vue&type=template&id=71fec8a5&scoped=true"
import script from "./Arms.vue?vue&type=script&lang=js"
export * from "./Arms.vue?vue&type=script&lang=js"
import style0 from "./Arms.vue?vue&type=style&index=0&id=71fec8a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fec8a5",
  null
  
)

export default component.exports